module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shift-import-dialog no-print"
  }, [_c('div', {
    staticClass: "shift-import-dialog__backdrop",
    on: {
      "click": _vm.close
    }
  }), _c('div', {
    staticClass: "shift-import-dialog__panel"
  }, [_c('div', {
    staticClass: "shift-import-dialog__header"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('shift_io.label.title')))]), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("　" + _vm._s(_vm.year) + "年" + _vm._s(_vm.month) + "月")]), _c('a', {
    staticClass: "shift-import-dialog__close",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×")])]), _c('div', {
    staticClass: "shift-import-dialog__body"
  }, [(_vm.notify) ? _c('div', {
    staticClass: "alert",
    class: _vm.notify.danger ? 'alert-danger' : 'alert-success'
  }, [_c('span', [_vm._v(_vm._s(_vm.notify.message))])]) : _vm._e(), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t('shift_io.label.file')))]), (_vm.inputClear) ? _c('input', {
    attrs: {
      "type": "file",
      "accept": ".xlsx"
    },
    on: {
      "change": _vm.onFileChange
    }
  }) : _vm._e(), _c('p', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t('shift_io.message.import_help')))])]), _c('p', [_c('a', {
    staticClass: "btn btn-info",
    class: (!_vm.file || _vm.running) ? 'disabled' : '',
    on: {
      "click": _vm.preview
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('shift_io.button.preview')))])])]), (_vm.previewResult) ? _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.$t('shift_io.label.preview_result')))]), _c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t('shift_io.label.applied')) + "：" + _vm._s(_vm.previewResult.applied))]), _vm._v("（" + _vm._s(_vm.$t('shift_io.label.cleared')) + "：" + _vm._s(_vm.previewResult.cleared) + "）\n　" + _vm._s(_vm.$t('shift_io.label.unchanged')) + "：" + _vm._s(_vm.previewResult.unchanged) + "\n　" + _vm._s(_vm.$t('shift_io.label.error_rows')) + "：" + _vm._s(_vm.errorCount))]), (_vm.hasErrors) ? _c('p', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" " + _vm._s(_vm.$t('shift_io.message.fix_errors')))]) : _vm._e(), (_vm.previewResult.created_users && _vm.previewResult.created_users.length > 0) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" " + _vm._s(_vm.$t('shift_io.message.created_users', {
    count: _vm.previewResult.created_users.length
  })))]), _c('ul', _vm._l((_vm.previewResult.created_users), function(createdUser) {
    return _c('li', [_vm._v(_vm._s(createdUser.login_id) + "　" + _vm._s(createdUser.user_name) + "（" + _vm._s(createdUser.days) + "日分）")])
  }))]) : _vm._e(), (_vm.previewResult.error_rows && _vm.previewResult.error_rows.length > 0) ? _c('div', [_c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('shift_io.label.error_rows')) + "：" + _vm._s(_vm.previewResult.error_rows.length))]), _c('ul', _vm._l((_vm.previewResult.error_rows), function(errorRow) {
    return _c('li', [_vm._v(_vm._s(errorRow.row) + "行目　" + _vm._s(errorRow.login_id) + "　" + _vm._s(errorRow.shift_date) + "　" + _vm._s(errorRow.message))])
  }))]) : _vm._e()]), (_vm.previewResult.rows && _vm.previewResult.rows.length > 0) ? _c('div', {
    staticClass: "preview-table"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th', [_vm._v(_vm._s(_vm.$t('shift_io.label.login_id')))]), _c('th', [_vm._v(_vm._s(_vm.$t('shift_io.label.user_name')))]), _c('th', [_vm._v(_vm._s(_vm.$t('shift_io.label.shift_date')))]), _c('th', [_vm._v(_vm._s(_vm.$t('shift_io.label.shift_class')))]), _c('th', [_vm._v(_vm._s(_vm.$t('shift_io.label.time')))]), _c('th', [_vm._v(_vm._s(_vm.$t('shift_io.label.break_time')))])])]), _c('tbody', _vm._l((_vm.previewResult.rows), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.login_id))]), _c('td', [_vm._v(_vm._s(row.user_name))]), _c('td', [_vm._v(_vm._s(row.shift_date))]), _c('td', [(row.cleared) ? _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.$t('shift_io.label.cleared_row')))]) : _c('span', [_vm._v(_vm._s(row.shift_class))])]), _c('td', [(row.time_from) ? _c('span', [_vm._v(_vm._s(row.time_from) + "〜" + _vm._s(row.time_to))]) : _vm._e()]), _c('td', [_vm._v(_vm._s(row.break_time))])])
  }))])]) : _vm._e(), (!_vm.importResult) ? _c('div', {
    staticClass: "panel-footer text-center"
  }, [_c('a', {
    staticClass: "btn btn-danger",
    class: _vm.canApply ? '' : 'disabled',
    on: {
      "click": _vm.apply
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('shift_io.button.apply')))])])]) : _vm._e()]) : _vm._e(), (_vm.importResult) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('shift_io.message.applied')))]), _c('span', [_vm._v("　" + _vm._s(_vm.$t('shift_io.label.applied')) + "：" + _vm._s(_vm.importResult.applied))]), (_vm.importResult.error_rows && _vm.importResult.error_rows.length > 0) ? _c('span', [_vm._v("　" + _vm._s(_vm.$t('shift_io.label.error_rows')) + "：" + _vm._s(_vm.importResult.error_rows.length))]) : _vm._e(), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t('shift_io.message.counter_manual_input')))])])]) : _vm._e()]), _c('div', {
    staticClass: "shift-import-dialog__footer text-center"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('shift_io.button.close')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-80460eee!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/shift-import-dialog.pug
// module id = 890
// module chunks = 1